import FiltersQuery from './FiltersQuery';

export default {
    mixins: [FiltersQuery],
    data() {
        return {
            activeFilters: {},
            layoutData: [],
            resetFilters: false,
            storeFilterKey: '',
        }
    },
    computed: {
        usersFilters() {
            return this.$store.getters.usersFilters;
        },
    },
}
